module.exports = __webpack_public_path__ + "static/cadastroEscala-77620c03f0bafdc84baedf1aae9ef612.gif";